// extracted by mini-css-extract-plugin
export var borderRadius = "_74-4";
export var large = "_74-3";
export var logoContainer = "_74-0";
export var nameLogo = "_74-2";
export var small = "_74-1";